import React from 'react';
import DynamicFieldsGrid from './DynamicFieldsGrid';

const IGNORE_KEYS = ['points_pct', 'origination_factor_pct','origination_factor'];

export default function OtherCostsFields({ control, FloatingInput, fields = null, sellerOtherCostArray = null, cleanNumber, parentName = null, getValues, setValue }) {
  // Determine current fields to render. Prefer the RHF field-array object when provided
  // so updates (replace/push/remove) will be reflected here.
  let currentFields = null;

  const salesPrice = typeof getValues === 'function' ? getValues('salesPrice') : null;

  // When a user manually edits a seller-other-cost field, persist their override
  // so that loan-type changes won't overwrite it. We store overrides in RHF
  // under 'sellerOtherCostMetaOverrides' as a map { camelKey: formattedValue }.
  const handleOnFormatted = (name, formatted) => {
    try {
      if (!name || typeof name !== 'string') return;
      // expect names like 'sellerOtherCostMeta[2].value' or similar
      const m = name.match(/\[(\d+)\]\.([a-zA-Z0-9_]+)/);
      if (!m) return;
      const idx = Number(m[1]);
      if (Number.isNaN(idx)) return;
      const item = Array.isArray(currentFields) ? currentFields[idx] : null;
      if (!item) return;
      const camel = item.camelKey || item.key || '';
      if (!camel) return;
      const overridesName = 'sellerOtherCostMetaOverrides';
      const prev = (typeof getValues === 'function' ? getValues(overridesName) : {}) || {};
      const next = { ...(prev || {}) };
      // store the formatted value (string) so it can be applied later
      next[camel] = formatted;
      setValue && setValue(overridesName, next, { shouldDirty: true, shouldTouch: true });
    } catch (e) {
      // ignore
    }
  };

  if (sellerOtherCostArray && Array.isArray(sellerOtherCostArray.fields)) {
    currentFields = sellerOtherCostArray.fields;
  } else if (Array.isArray(fields) && fields.length) {
    currentFields = fields;
  } else if (parentName && typeof getValues === 'function') {
    // fallback to reading from RHF values if available
    try {
      const val = getValues(parentName);
      if (Array.isArray(val) && val.length) currentFields = val;
    } catch (e) {
      // ignore
    }
  }
  // no-op: parent triggers overall calculation

  if (!Array.isArray(currentFields) || currentFields.length === 0) return null;

  return (
    <DynamicFieldsGrid
      fields={currentFields}
      control={control}
      FloatingInput={FloatingInput}
      cleanNumber={cleanNumber}
      ignoreKeys={IGNORE_KEYS}
      parentName={parentName}
      onFormatted={handleOnFormatted}
      getValues={getValues}
      setValue={setValue}
      salesPrice={salesPrice}
    />
  );

}
